<template>
    <div>
        <v-row v-if="data && Object.keys(data).length > 0">
            <v-col cols="12">
                <v-card-title>
                    <span class="headline"><b>{{title}}</b></span>
                </v-card-title>
            </v-col>
        </v-row>
        
        <v-row v-if="data && Object.keys(data).length > 0">
            <v-col cols="12">
                <v-row v-for="(value, key) in data" :key="key">
                    <template v-if="!Array.isArray(value)">
                        <v-col cols="1"></v-col>
                        <v-col cols="10">
                            <EntityInstanceViewer :entity_instance_id="value" :intern_key="key"></EntityInstanceViewer>
                        </v-col>
                        <v-col cols="1"></v-col>
                    </template>
                    <template v-else>
                        
                        <v-col cols="1"></v-col>
                        <v-col cols="10">
                            <ListOfInstancesEditor :entity_instances_ids="value" :intern_key="key"></ListOfInstancesEditor>
                        </v-col>
                        <v-col cols="1"></v-col>

                    </template>
                </v-row>
            </v-col>
        </v-row>
    
    </div>
   
</template>

<script>
import DocTextField from '@/components/DocTextField.vue';
import EntityInstanceViewer from '@/modules/entities/infra/EntityInstanceViewer.vue'
import ListOfInstancesEditor from '@/modules/entities/infra/ListOfInstancesEditor.vue'

export default {
    name: "ExtractedDataComponent",
    components: {
        DocTextField,
        EntityInstanceViewer,
        ListOfInstancesEditor
    },
    data() {
        return {
        }
    },
    props: {
        data:{
            type: [Object],
            required: true,
            default: null
        },
        title:{
            type: String,
            required: false,
            default: 'Información extraída'
        }
    },
    computed: {
    },
    methods: {
    }
    
};
</script>

<style scoped>
.primary-background {
    background-color: #663399;
}
.primary-border {
    border-color: #663399 !important;
}
</style>
<style>
/* .toolbar > .v-toolbar__content {
    justify-content: space-around;
} */

.stepper.v-stepper--vertical {
    padding: 0px ;
} 

.stepper.v-stepper {
    box-shadow: none;
}
</style>